import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Shell } from "@/components/layout/Shell";
import { HeroSlider } from "@/components/home/HeroSlider";
import { PromotionCarousel } from "@/components/home/PromotionCarousel";
import { AboutSection, PresidentMessage, QuickActions, StatsBand } from "@/components/home/Sections";
import { CommitteeGrid, EventsPreview, HomeLower, SponsorStrip } from "@/components/home/Showcase";

export const useBootstrap = () => {
  const [data, setData] = useState(null);
  useEffect(() => {
    api("/public/bootstrap").then(setData).catch(() => setData({}));
  }, []);
  return data;
};

export const resolveStats = data =>
  (data.statistics || []).map(s => {
    if (s.auto === "members") return { ...s, number: `${data.counts?.members || 0}+` };
    if (s.auto === "committee") return { ...s, number: `${data.counts?.committee || 0}+` };
    if (s.auto === "events") return { ...s, number: `${data.counts?.events || 0}+` };
    return s;
  });

export default function Home() {
  const data = useBootstrap();
  if (!data) return <div className="loading" data-testid="home-loading">Loading DCEA…</div>;
  const settings = data.settings || {};
  const president = (data.committee || []).find(c => (c.position || "").toLowerCase() === "president") || data.committee?.[0];

  const blocks = {
    hero: <HeroSlider slides={data.hero || []} counts={data.counts || {}} />,
    quick_actions: <QuickActions items={data.quick_actions || []} />,
    promotions: <PromotionCarousel promotions={data.promotions || []} />,
    about: <AboutSection tagline={settings.tagline} />,
    stats: <StatsBand stats={resolveStats(data)} />,
    president: <PresidentMessage president={president} />,
    committee: <CommitteeGrid committee={data.committee || []} />,
    events: <EventsPreview events={data.events || []} />,
    lower: <HomeLower albums={data.albums || []} news={data.news || []} />,
    sponsors: <SponsorStrip sponsors={data.sponsors || []} />
  };
  const sections = (data.sections || Object.keys(blocks).map(key => ({ key, enabled: true })))
    .filter(s => s.enabled !== false && blocks[s.key]);

  return (
    <Shell>
      <main data-testid="home-main">
        {sections.map(s => <div key={s.key} data-testid={`home-section-${s.key}`}>{blocks[s.key]}</div>)}
      </main>
    </Shell>
  );
}
